import React from "react";
import { Card, CardBody } from "reactstrap";
import Dashboardsvg from "../../_assets/icons/dashboardsvg.svg";
import Spinner from "../../shared/components/scrollbar/lib/spinner";


const OverviewCard = ({
  label,
  amount,
  borderColor,
  visible = true,
  showDollar,
  showNaira
}) => {
  return (
    <Card
      className=""
      style={{
        backgroundColor: "#FBFBFB",
        borderRadius: "0.25rem",
        height: "100px",
        borderLeft: `0.3rem solid ${borderColor}`,
      }}
    >
      <CardBody>
        <div className="d-flex">
          <div className="stats">
            <div>
              <img className="w-[40px]" src={Dashboardsvg} alt="airline icon" />{" "}
              <small>{label}</small>
            </div>
            {visible === false ? (
              <h4
                className="mt-1 mb-4 font-bold font-12"
                style={{ marginLeft: "10px",fontSize:"16px" }}
              >
                {showNaira && (<span>&#8358;</span>)}
                {showDollar && (<span>&#36;</span>)}
                {amount}
              </h4>
            ) : (
              <div>
                <Spinner size={20} visible={visible} />
              </div>
            )}
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default OverviewCard;



// WEBPACK FOOTER //
// ./src/views/avicollectDashboard/over-view.js